'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var addAll = require('./add-all');

var last = require('it-last');

var configure = require('../lib/configure');

module.exports = function (options) {
  var all = addAll(options);
  return configure(function () {
    return /*#__PURE__*/function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                return _context.abrupt("return", last(all(_objectSpread({
                  path: path
                }, options), options)));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function add(_x) {
        return _add.apply(this, arguments);
      }

      return add;
    }();
  })(options);
};